import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1319d000"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 최종 수취액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 이전 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 이 조건으로 팔기 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 다음 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selected_partnership_stake = _resolveComponent("selected-partnership-stake")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_keypad = _resolveComponent("keypad")!
  const _component_calc_expected_price = _resolveComponent("calc-expected-price")!
  const _component_lead_angel_carried_interest = _resolveComponent("lead-angel-carried-interest")!
  const _component_sell_regist_result = _resolveComponent("sell-regist-result")!
  const _component_view_my_stake = _resolveComponent("view-my-stake")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          "justify-content": "space-between",
          direction: "column",
          height: "100%",
          p: '16px 20px 0px 20px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_selected_partnership_stake, {
              "component-number": _ctx.componentNumber,
              "sell-amount": _ctx.sellAmount,
              "sell-price": _ctx.sellPrice,
              "final-sell-info": _ctx.finalSellInfo,
              "income-fee": _ctx.LeadFinalSellInfo.incomeFee,
              "carried-interest": _ctx.LeadFinalSellInfo.carriedInterest
            }, null, 8, ["component-number", "sell-amount", "sell-price", "final-sell-info", "income-fee", "carried-interest"]),
            _createVNode(_component_ag_box, null, {
              default: _withCtx(() => [
                (_ctx.componentNumber === 1 || _ctx.componentNumber === 2)
                  ? (_openBlock(), _createBlock(_component_ag_box, {
                      key: 0,
                      "margin-top": "10px",
                      "margin-bottom": "16px",
                      "text-align": "center"
                    }, {
                      default: _withCtx(() => [
                        ((_ctx.componentNumber === 1 && !_ctx.sellPrice) || (_ctx.componentNumber === 2 && !_ctx.sellAmount))
                          ? (_openBlock(), _createBlock(_component_ag_text, {
                              key: 0,
                              class: "price-font",
                              dp: "block",
                              "margin-bottom": "20px",
                              color: "gray6"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.componentNumber === 1 ? '판매희망주당가격' : '판매희망금액'), 1)
                              ]),
                              _: 1
                            }))
                          : ((_ctx.componentNumber === 1 && _ctx.sellPrice) || (_ctx.componentNumber === 2 && _ctx.sellAmount))
                            ? (_openBlock(), _createBlock(_component_ag_text, {
                                key: 1,
                                class: "price-font",
                                dp: "block",
                                "margin-bottom": "20px"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.$filters.currency(_ctx.componentNumber === 1 ? _ctx.sellPrice : _ctx.sellAmount)), 1),
                                  _hoisted_1
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_ag_text, {
                          typography: "'main14r'",
                          dp: "block",
                          "margin-bottom": "8px",
                          color: "gray3"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.componentNumber === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "주당 평균 구매 가격 " + _toDisplayString(_ctx.$filters.currency(_ctx.openTypeRef === 'edit' ? _ctx.dealInfo.avgBuyPrice : _ctx.dealInfo.price)) + " 원", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_3, "판매가능 금액 10,000 원 ~ " + _toDisplayString(_ctx.$filters.currency(Math.floor(_ctx.totalPrice))) + " 원", 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.componentNumber === 1 || _ctx.componentNumber === 2)
                  ? (_openBlock(), _createBlock(_component_keypad, {
                      key: 1,
                      "model-value": _ctx.componentNumber === 1 ? _ctx.sellPrice : _ctx.sellAmount,
                      type: _ctx.componentNumber,
                      onSellAll: _ctx.sellAllStake,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputFunc($event)))
                    }, null, 8, ["model-value", "type", "onSellAll"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.componentNumber === 3)
              ? (_openBlock(), _createBlock(_component_calc_expected_price, {
                  key: 0,
                  parent: _ctx.clickScreen,
                  "final-sell-info": _ctx.finalSellInfo
                }, null, 8, ["parent", "final-sell-info"]))
              : _createCommentVNode("", true),
            (_ctx.componentNumber === 4)
              ? (_openBlock(), _createBlock(_component_lead_angel_carried_interest, {
                  key: 1,
                  "final-sell-info": _ctx.finalSellInfo,
                  "income-fee": _ctx.LeadFinalSellInfo.incomeFee,
                  "carried-interest": _ctx.LeadFinalSellInfo.carriedInterest,
                  revenue: _ctx.LeadFinalSellInfo.revenue
                }, null, 8, ["final-sell-info", "income-fee", "carried-interest", "revenue"]))
              : _createCommentVNode("", true),
            (_ctx.componentNumber === 5)
              ? (_openBlock(), _createBlock(_component_ag_box, {
                  key: 2,
                  pt: "16px",
                  style: {"border-top":"1px solid #F9F9FB"},
                  dp: "flex",
                  "align-items": "center",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, { typography: "tit16b" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, {
                          typography: "tit24b",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.finalProfit)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text, {
                          style: {"font-size":"24px"},
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_sell_regist_result, {
          "request-id": _ctx.requestId,
          "is-open": _ctx.resultModal,
          onClose: _ctx.closeModal,
          onFail: _ctx.openRegistStatus
        }, null, 8, ["request-id", "is-open", "onClose", "onFail"]),
        _createVNode(_component_view_my_stake, {
          "open-type": 'result',
          "is-open": _ctx.viewMyStakeOpen,
          onClose: _cache[1] || (_cache[1] = () => _ctx.viewMyStakeOpen = false)
        }, null, 8, ["is-open"])
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, {
      p: "20px",
      mb: "safeAreaBottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          gap: "sp6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, { color: "black" }),
            _createVNode(_component_ag_button, {
              corner: "10px",
              outline: "primary",
              width: "100%",
              disabled: (_ctx.openTypeRef === 'edit' || _ctx.openTypeRef === 'stakeSelected') && _ctx.componentNumber === 1,
              onClickCapture: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`이전`});_ctx.goToPrevious()})
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_ag_button, {
              corner: "10px",
              disabled: _ctx.checkDisable,
              width: "100%",
              onClickCapture: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`다음`});_ctx.goToNext()})
            }, {
              default: _withCtx(() => [
                (_ctx.componentNumber===5)
                  ? (_openBlock(), _createBlock(_component_ag_text_s, { key: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_ag_text_s, { key: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}